import { useEffect, useState } from "react";
import { LiveOrderTableInfoDTO } from "../../../../../models/table/table.response";
import { useNotification } from "../../../../toster-notification/NotificationContext";
import { tableService } from "../../../../../services/tableService";
import { handleErrorNotification } from "../../../../../utils/errorNotificatioMessage";
import { OrderStatusType, orderStatusTypeToClassName, orderStatusTypeToString } from "../../../../../models/base/OrderStatusType";
import { orderService } from "../../../../../services/orderService";
import { tableStatusTypeToColor, tableStatusTypeToString } from "../../../../../models/base/TableStatusType";
import { tableShapeToIcon } from "../../../../../models/base/TableShapeType";
import { BoxIcon, ClocckGreyIcon, DineInWhiteIcon, DollarGreenIcon, MessageDarkOrangeIcon, MessageGreenIcon, UserGreyIcon, WallClockIcon } from "../../../../../assets/icons";
import { ToLocalDateTimeString } from "../../../../../utils/dateFormater";
import Loader from "../../../../shared/Loader";
import { LiveOrderInfoDTO } from "../../../../../models/shared/response";
import { useParams } from "react-router-dom";


interface OrderInfoModalViewProps {
    selectedOrderId: string;
    listItemOrder?: boolean;
    onClose: () => void;
}

const OrderInfoModalView: React.FC<OrderInfoModalViewProps> = ({ selectedOrderId, listItemOrder, onClose }) => {

    const [order, setOrder] = useState<LiveOrderInfoDTO | null>(null);

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();

    const localId = useParams().localId;


    useEffect(() => {
        fetchOrderInfo();
    }, [selectedOrderId]);


    const fetchOrderInfo = async () => {
        if (!selectedOrderId || !localId)
            return;

        setLoading(true);
        try {
            const response = await orderService.getLiveOrderInList(localId, selectedOrderId);
            if (response.success && response.data) {
                setOrder(response.data);
            } else {
                notify("error", "Greška pri učitavanju porudžbine");
            }
        } catch (error) {
            notify("error", "Greška pri učitavanju porudžbine");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const handleOrderStatusChange = async (orderId: string, newStatus: OrderStatusType) => {
        if (!localId) {
            notify("error", "ID lokala nije prosleđen");
            return;
        }

        if (!orderId) {
            notify("error", "ID porudžbine nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.changeOrderStatus(localId, orderId, newStatus);

            if (response.success) {
                notify("success", "Uspešno ažuriran status porudžbine.");
                fetchOrderInfo();
            } else {
                notify("error", "Greška pri ažuriranju statusa porudžbine", response.message || "Došlo je do greške pri ažuriranju statusa porudžbine.");
            }
        } catch (error) {
            notify("error", "Greška pri ažuriranju statusa porudžbine", "Došlo je do greške pri ažuriranju statusa porudžbine.");
            console.error(error);
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const handleOrderStatusToNext = async (orderId: string) => {
        if (!localId) {
            notify("error", "ID lokala nije prosleđen");
            return;
        }

        if (!orderId) {
            notify("error", "ID porudžbine nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.changeOrderStatusToNext(localId, orderId);

            if (response.success) {
                notify("success", "Uspešno ažuriran status porudžbine.");
                fetchOrderInfo();
            }
            else {
                notify("error", "Greška pri ažuriranju statusa porudžbine", response.message || "Došlo je do greške pri ažuriranju statusa porudžbine.");
            }
        } catch (error) {
            notify("error", "Greška pri ažuriranju statusa porudžbine", "Došlo je do greške pri ažuriranju statusa porudžbine.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };


    if (!selectedOrderId) {
        return (
            <div className="admin-settings-box-div lo-table-info-block orders-list">
                Izaberite porudžbinu sa liste
            </div>
        )
    }

    if (!order) {
        return (
            <div className="admin-settings-box-div lo-table-info-block orders-list">
                Nema podataka o izabranoj porudžbini
            </div>
        )
    }

    if (loading) {
        return (
            <div className="admin-settings-box-div lo-table-info-block orders-list">
                <Loader fullscreen={false} />
            </div>
        )
    }



    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <section className="live-order-modal" onClick={onClose}>
                    <div className="w-layout-blockcontainer container w-container">
                        <div className="live-order-modal-wrapper">
                            <div className="admin-settings-box-div lo-table-info-block lo-modal" onClick={(e) => e.stopPropagation()}>
                                <div className="lo-table-info-header">
                                    <div className={`lo-table-info-header-image-div `}>
                                        <img loading="lazy" src={DineInWhiteIcon} alt="" className="lo-table-info-header-image" />
                                    </div>
                                    <div className="div-block-15">
                                        <div className="lo-table-info-table-number">Porudzbina #{order.id}</div>
                                        <div className="lo-table-info-table-status">Status: {orderStatusTypeToString(order.currentStatus)}</div>
                                    </div>
                                </div>
                                <div className="lo-table-active-status-div">
                                    <div className="admin-settings-box-div lo-table-status lo-modal">
                                        <div className="lo-table-active-orders-bg">
                                            <div className="lo-table-active-orders-icon"></div>
                                        </div>
                                        <div>
                                            <div className="text-block-14">Stavke</div>
                                            <div className="lo-table-active-orders-number lo-modal">
                                                {order.items.length}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="admin-settings-box-div lo-table-status lo-modal">
                                        <div className="lo-table-active-orders-bg total-amount">
                                            <img loading="lazy" src={DollarGreenIcon} alt="" className="icon-size-20" />
                                        </div>
                                        <div>
                                            <div className="text-block-14">Ukupno</div>
                                            <div className="lo-table-active-orders-number lo-modal">
                                                {order.items.reduce((total, item) => total + item.productVariantPrice * item.quantity, 0).toFixed(2)} RSD
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="lo-table-orders-block-div lo-modal">
                                    <div className="lo-table-orders-list-div lo-modal">

                                        <div className={`admin-settings-box-div lo-table-order-div lo-modal ${orderStatusTypeToClassName(order.currentStatus)}`} key={order.id}>
                                            <div className="lo-table-order-header-div">
                                                <div className="lo-table-order-header-top-div">
                                                    <div className="to-table-order-count lo-modal">Porudzbina #{order.id.slice(0, 8)}</div>
                                                    <div className={`small-box-div ${orderStatusTypeToClassName(order.currentStatus)}`}>
                                                        <div className="text-block-12">{orderStatusTypeToString(order.currentStatus)}</div>
                                                    </div>
                                                </div>

                                                {/* Order quick-info (icons)*/}
                                                <div className="lo-table-order-header-bottom-div lo-modal">
                                                    <div className="lo-table-order-header-bottom">
                                                        <img loading="lazy" src={WallClockIcon} alt="" className="icon-size-16" />
                                                        <div className="text-block-39">{Math.floor((new Date().getTime() - new Date(order.createdAt).getTime()) / 60000)} min</div>
                                                    </div>
                                                    <div className="lo-table-order-header-bottom">
                                                        <img loading="lazy" src={ClocckGreyIcon} alt="" className="icon-size-16" />
                                                        <div>{ToLocalDateTimeString(order.createdAt.toString())}</div>
                                                    </div>
                                                    <div className="lo-table-order-header-bottom">
                                                        <img loading="lazy" src={BoxIcon} alt="" className="icon-size-16" />
                                                        <div>{order.items.length}</div>
                                                    </div>
                                                    <div className="lo-table-order-header-bottom">
                                                        <img loading="lazy" src={UserGreyIcon} alt="" className="icon-size-16" />
                                                        <div>{order.fullName}</div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="lo-table-order-product-list-block">
                                                <div className="lo-table-order-product-list-div">
                                                    {order.items.map(item => (
                                                        <div className="lo-table-order-product-div lo-modal" key={item.id}>
                                                            <div className="lo-table-order-product-count-div">
                                                                <div>{item.quantity}x</div>
                                                            </div>
                                                            <div className="lo-table-order-product-price-div lo-modal">
                                                                <div className="lo-table-order-product-sum-price">{item.productVariantPrice * item.quantity} RSD</div>
                                                                <div className="description-text product-price">{item.productVariantPrice} RSD/kom</div>
                                                            </div>
                                                            <div className="lo-table-order-product-info-div" id="w-node-_1aaaa707-3020-e515-a7c8-1af424701876-1cee91cf">
                                                                <div className="lo-table-order-product-name lo-modal">{item.productName} <span className="text-span-10">/{item.productVariantLabel}</span></div>
                                                                {/* <div className="lo-table-order-product-description">
                                                                    {item.description}<br />
                                                                </div>
                                                                <div className="lo-table-order-product-description-2">
                                                                    Paradajz sos, mocarela, bosiljak<br />desc 2
                                                                </div> */}
                                                                {item.description && (
                                                                    <div className="lo-table-order-product-message">
                                                                        <img loading="lazy" src={MessageDarkOrangeIcon} alt="" className="icon-size-12" />
                                                                        <div>{item.description}</div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {
                                                order.description && (
                                                    <div className="lo-table-order-message-div">
                                                        <div className="lo-table-order-message-image-div">
                                                            <img loading="lazy" src={MessageGreenIcon} alt="" className="icon-size-16" />
                                                        </div>
                                                        <div>
                                                            <div className="description-text fs-12">Napomena za porudžbinu:</div>
                                                            <div className="text-block-13 lo-modal">{order.description}</div>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            < div className="lo-table-order-total-price lo-modal" >
                                                <div>Ukupno:</div>
                                                <div>{order.items.reduce((total, item) => total + item.productVariantPrice * item.quantity, 0).toFixed(2)} RSD</div>
                                            </div>

                                            <div className="lo-table-order-status-div">
                                                <div className="form-block-4 w-form">
                                                    <form className="modal-form">
                                                        <div className="description-text">
                                                            Status porudžbine<br />
                                                        </div>
                                                        <div className="div-block-16">
                                                            <select
                                                                className="form-select auto-width w-select"
                                                                value={order.currentStatus}
                                                                onChange={(e) =>
                                                                    handleOrderStatusChange(order.id, Number(e.target.value) as OrderStatusType)
                                                                }
                                                            >
                                                                <option value={OrderStatusType.Ordered}>Poručeno</option>
                                                                <option value={OrderStatusType.Recived}>Primljeno</option>
                                                                <option value={OrderStatusType.Served}>Posluženo</option>
                                                                <option value={OrderStatusType.Bill}>Račun</option>
                                                                <option value={OrderStatusType.Paid}>Plaćeno</option>
                                                                <option value={OrderStatusType.Cancelled}>Otkazano</option>
                                                                <option value={OrderStatusType.Finished}>Završeno</option>
                                                            </select>
                                                            <div className="button-primary order-next-status" onClick={() => handleOrderStatusToNext(order.id)}>
                                                                <div>&gt;</div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div >
                </section >

            )
            }
        </>

    );
};

export default OrderInfoModalView;